import {useParams} from "react-router";

const useCaseNum = () => {
    return useParams().case_num;
};

export default useCaseNum;
